// import React from 'react';
// import {graphql} from 'react-apollo';
// import {flowRight as compose} from 'lodash';

// import queries from '../../../../../src/utils/queries'

const osDx = async (recurso, elementoArchivo, argsSelDpto, editSeqfindOneAndUpdate,
    createOdeS, editOdeSUpdDoc, fechaHoraHoy, tipoOSIns, descrCategOST) => {

  const nextVal = async (name) => {
    const argsUpd = {
      coleccion: name,
    }
    const response = await editSeqfindOneAndUpdate({
      variables: argsUpd
    });
    return response.data.editSeqfindOneAndUpdate.seq
  }

  //ACTUALIZAR BD
  const crudBD = async (operacionCRUD, args, i)=>{
    if(args.ctrlCampo === 'CRUD'){
      const {data} = await operacionCRUD({
        variables: args
      });
      //Se utiliza para traer el _id del documento creado
      if(args.ctrl_id === 'SI_ID'){
        if(Object.values(data)[0]._id){
          return Object.values(data)[0]._id
        }else{
          return 0
        }
      }
    }else{
      if(args.ctrlCampo === "MANY"){
        await operacionCRUD({
          variables: args
        });
      }
    }
  }

  const updColecc = async (crudColecc, argsCrud, totDocCRUD)=>{
    let codigo = 0
    if(argsCrud[0].ctrl_id === 'SI_ID'){
      codigo = await crudBD(crudColecc[0], argsCrud[0], 0)
    }else{
      await crudBD(crudColecc[0], argsCrud[0], 0)
    }
    if(codigo!==0){
      for(let i=1; i<totDocCRUD; i++){
        argsCrud[i]._id = codigo
      }
    }
    for(let i=1; i<totDocCRUD; i++){
      await crudBD(crudColecc[i], argsCrud[i], i)
    }
  }

  let args = elementoArchivo
  let fechaHoy = fechaHoraHoy.substr(0, 10)
  let horaOS = fechaHoraHoy.substr(11, 5)

  let contrato = elementoArchivo.contrato

  // console.log(args, fechaHoy, horaOS)
  // console.log(recurso)
      //CREAR LA OS
      let argsAdd = argsSelDpto
      argsAdd['_idTipoOS'] = tipoOSIns._idTipoOS
      argsAdd['codigoTipoOS'] = tipoOSIns.codigoTipoOS
      argsAdd['descrTipoOS'] = tipoOSIns.descrTipoOS
      argsAdd['observacAB'] = args.observacAB
      argsAdd['numeroOS'] = await nextVal('odess')
      // argsAdd['codigoTipoDocV'] = argsAdd.codigoTipoDocV
      // argsAdd['numeroDocumV'] = argsAdd.numeroDocumV
      // argsAdd['descrRecursoV'] = argsDocum.descrRecursoV!=="Seleccionar..."?argsDocum.descrRecursoV:null
      argsAdd['contrato'] = args.contrato
      argsAdd['fechaEjec'] = fechaHoy
      argsAdd['fechaFra'] = fechaHoy
      argsAdd['fechaCreate'] = fechaHoy
      argsAdd['horaSolic'] = horaOS
      if(!descrCategOST||descrCategOST==="Seleccionar..."){
        argsAdd['descrCategOST'] = ""
      }else{
        argsAdd['descrCategOST'] = descrCategOST
      }
      // console.log(argsAdd)
      let responseOS = await createOdeS({
        variables: argsAdd
      });

      let argsUpd = {}
      //Asignar recursos a la OS
      let updRec = []
      // console.log(recurso, argsSelDpto)
      if(argsSelDpto.codigoTipoDocT){
        if(recurso.length===1){
          let elemento = recurso[0]
          argsUpd = {
            "tipoAct": "EditarRecursos",
            "numeroOS": argsAdd.numeroOS,
            "_idRecurso" : elemento._id,
            "codigoTipoDoc" : elemento.codigoTipoDoc,
            "numeroDocum" : elemento.numeroDocum,
            "descrRecurso" : elemento.descrRecurso,
            "_idTipoRec" : elemento.tiporec._id,
            "descrTipoRec" : elemento.tiporec.descrTipoRec,
            "areaAprovech" : elemento.tiporec.areaAprovech
          };
          updRec.push(argsUpd)
          // console.log(argsUpd)
        }
      }

      //Actualizar bd
      let numDocCRUD = 0
      let totDocCRUD = 1
      let argsCrud = []
      let crudColecc = []
      for(let iii=0; iii<totDocCRUD; iii++){
        argsCrud.push({ctrlCampo: 'NO_CRUD'})
      }
      for(let iii=0; iii<totDocCRUD; iii++){
        crudColecc.push(editOdeSUpdDoc)
      }

      argsCrud[numDocCRUD] = updRec[0]
      argsCrud[numDocCRUD]['ctrlCampo'] = 'CRUD'
      argsCrud[numDocCRUD]['ctrl_id'] = 'NO_ID'

      // console.log(argsCrud, totDocCRUD)
      await updColecc(crudColecc, argsCrud, totDocCRUD)
      //FIN crear OS

  const contratoAj = {contrato}
  // console.log(contrato)
  return contratoAj
}

export default osDx

// export default compose(
//   // graphql(queries.query.allMovClientes, {name:'allMovClientes', options: (props) => {return {variables: {contrato: "12", orden: '_id'}}}}),

//   // graphql(queries.mutation.editOdeS, {name:'editOdeS'}),

// )(osDx)
